import React, { useContext } from "react";
import { LoginPopupContext } from "../../../templates/article";
import { Link, navigate } from "gatsby";
import AuthContext from "../../../services/firebase/auth-context/provider";
var SubscriptionRequestEdition = function SubscriptionRequestEdition(_ref) {
    var loadFullArticle = _ref.loadFullArticle, _ref$type = _ref.type, type = _ref$type === void 0 ? "paywall" : _ref$type;
    var authenticated = useContext(AuthContext)[0].authenticated;
    var LoginContext = useContext(LoginPopupContext);
    var smallTitle = "Nur für Abonnenten";
    var coloringBox = "border-makroOrange bg-makroOrangeLight";
    var coloringSmallTitle = "bg-makroOrange";
    var coloringButton = "border-makroOrange bg-makroOrange hover:text-makroOrange";
    var loadArticle = /*#__PURE__*/ React.createElement(React.Fragment, null);
    if (type == "free") {
        smallTitle = "Kostenloser Artikel";
        coloringBox = "border-makroBlue bg-makroBlueLight";
        coloringSmallTitle = "bg-makroBlue";
        coloringButton = "border-makroBlue bg-makroBlue hover:text-makroBlue";
        loadArticle = /*#__PURE__*/ React.createElement("button", {
            onClick: loadFullArticle,
            className: "w-full text-lg text-white mt-3 px-2 pt-2 pb-1 border-2 border-solid border-gray-600 bg-gray-600 hover:text-gray-600 hover:bg-transparent"
        }, "GANZEN ARTIKEL LESEN");
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "shadow border-t-8 border-solid " + coloringBox + " mt-8 px-4 py-6"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-4xl",
        style: {
            fontSize: "2.6em"
        }
    }, "Nichts schreibt sich von allein!"), /*#__PURE__*/ React.createElement("div", {
        className: "inline-block font-bold text-lg text-white " + coloringSmallTitle + " px-4 py-1 my-4 -ml-4"
    }, smallTitle), /*#__PURE__*/ React.createElement("div", {
        className: "text-gray-800 col-span-2",
        style: {
            columnCount: 2
        }
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "MAKROSKOP analysiert wirtschaftspolitische Themen aus einer postkeynesianischen Perspektive und ist damit in Deutschland einzigartig. MAKROSKOP steht f\xFCr das gro\xDFe Ganze. Wir haben einen Blick auf Geld, Wirtschaft und Politik, den Sie so woanders nicht finden."), /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "Dabei leben wir von unseren Autoren, ihren Recherchen, ihrem Wissen und ihrem Enthusiasmus. Gemeinsam scheren wir aus den schmaler werdenden Leitplanken des Denkens aus."), /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "Wir verlassen die journalistische Filterblase, in der sich viele eingerichtet haben. Wir \xF6ffnen Fenster und bringen frische Luft in die engen und verstaubten Debattenr\xE4ume."), /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "Brauchen Sie auch frische Luft? Dann folgen Sie einfach dem Button."), /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren/",
        className: "w-full inline-block text-lg text-center text-white mt-8 px-2 pt-2 pb-1 border-2 border-solid " + coloringButton + " hover:bg-transparent hover:bg-transparent-important"
    }, "ABONNIEREN SIE MAKROSKOP"), loadArticle, /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }, "Schon Abonnent? Dann hier", " ", /*#__PURE__*/ React.createElement("span", {
        className: "font-bold underline hover:no-underline cursor-pointer",
        onClick: !authenticated ? LoginContext.onLoginClick : function () {
            return navigate("/anmelden/");
        }
    }, "einloggen"), "!")));
};
export default SubscriptionRequestEdition;
